import { AI_COACH_CONTENT_FETCH_ENDED, AI_COACH_CONTENT_FETCH_STARTED } from '../actions/types';
const defaultState = {
  status: 'initial'
};
const aiCoachContentReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case AI_COACH_CONTENT_FETCH_STARTED:
      return {
        exerciseId: action.exerciseId,
        status: 'fetching'
      };
    case AI_COACH_CONTENT_FETCH_ENDED:
      return {
        content: action.content,
        derivedCourseContentId: action.derivedCourseContentId,
        exerciseId: action.exerciseId,
        status: 'fetched'
      };
    default:
      return state;
  }
};
export default aiCoachContentReducer;